import { render, staticRenderFns } from "./ElderlyInsCheckIn3.vue?vue&type=template&id=24c593af&scoped=true&"
import script from "./ElderlyInsCheckIn3.vue?vue&type=script&lang=js&"
export * from "./ElderlyInsCheckIn3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c593af",
  null
  
)

export default component.exports